import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link, Node } from '../../d3';
import APP_CONFIG from '../../app.config';
import { ArticleService } from './../../core/services/articles/article.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

interface NodeType {
    // Define the structure of each node here
    id: number;
    name: string;
    // add other properties as needed
}

interface ResponseData {
    nodes: Array<NodeType>;
}

const width = window.innerWidth;

@Component({
    selector: 'app-article-network-graph',
    templateUrl: './article-network-graph.component.html',
    styleUrls: ['./article-network-graph.component.scss'],
})
export class ArticleNetworkGraphComponent {
    articleNetworkSubject!: Subscription;
    @Input('articleId') networkRootId: any;
    @Input('suppressSummary') suppressSummary: any;
    @Output() articleNetworkApiHandler = new EventEmitter<any>();
    nodes: Array<Node> = [];
    links: Array<Link> = [];
    topicId: number = 1;
    headNode: any;
    idToRemove: any;
    childNodesArrayToBeDeleteToBeDeleted: Array<Node> = [];
    //childNodesArrayToBeDelete = [];
    childNodesArrayToBeDelete: Array<Node> = [];
    intervalForMainSKG_API: any;
    isCompleted = false;
    showSwitchButtons = true;
    showGyanIsNotReadyMessage = false;
    hideText = true;
    showBackgroundImage = false;
    showConsolidateMsgPermission = false;
    isNetwork = false;
    interval: any;
    articleId!: number;
    message: any;
    articleTitle!: string;
    networkRootIdSub!: string;
    loadingGraph = false;
    gyanTitle!: string;
    isMobile = width < 768 ? true : false;

    constructor(
        private commonServiceService: CommonServiceService,
        private articleService: ArticleService,
        private authService: AuthService,
        private toastrService: ToastrService,
        private localStorageService: LocalStorageService,
    ) {
        this.articleNetworkSubject = this.commonServiceService.articleNetworkSubject$.subscribe((data) => {
            //this.networkRootId = data.networkRootId;
            this.articleId = data.articleId;
            this.articleTitle = data.articleTitle;
            this.networkRootIdSub = data.networkRootId;
            //this.gyanTitle = data.gyanTitle;
            this.nodes = [];
            this.links = [];
            this.message = '';
            this.firstLevelGraphData();

            const gyanData = this.localStorageService.getItem('gyanData');
            this.gyanTitle = gyanData.gyanName;
        });
    }

    ngOnInit() {
        //  console.log('ArticleNetworkGraphComponent.ngOnInit');
        //this.firstLevelGraphData();
        //this.getAccessPermission();
    }

    firstLevelGraphData() {
        const firstLevelNode = {
            //topicId: this.networkRootId,
            recordId: null,
            isHeadNode: true,
            type: 1,
            limit: APP_CONFIG.NODE_LIMIT,
            offset: APP_CONFIG.NODE_INITIAL_OFFSET,
            articleId: this.articleId,
        };
        this.getArticleGraphData(firstLevelNode, true, {});
        // console.log('firstLevelGraphData');
    }

    onDoubleClickSelectedNode(selectedNode: any) {
        if (selectedNode.offset == null || selectedNode.offset == undefined) {
            selectedNode.nodeClicked = true;
            selectedNode.collapse = true;
            return;
        }
        if (!selectedNode.nodeClicked) {
            //if (selectedNode.isNextLevel && !selectedNode.nodeClicked) {
            let reqConceptNondeSummary = {};
            if (selectedNode.data.data.isDummy) {
                reqConceptNondeSummary = {
                    topicId: selectedNode.data.data.actualId,
                    recordId: selectedNode.data.data.id,
                    isHeadNode: false,
                    type: selectedNode.data.data.type,
                    limit: APP_CONFIG.NODE_LIMIT,
                    offset: selectedNode.offset,
                };
            } else {
                reqConceptNondeSummary = {
                    topicId: selectedNode.id,
                    recordId: null,
                    isHeadNode: false,
                    type: selectedNode.data.data.type,
                    limit: APP_CONFIG.NODE_LIMIT,
                    offset: selectedNode.offset,
                }; // else send it as node payload
            }

            if (selectedNode.id != this.topicId) {
                this.getArticleGraphData(reqConceptNondeSummary, false, selectedNode);
            }
        } else {
            // for first level of nodes,  grey out if no chidren data available
            selectedNode.isNextLevel = true;
            selectedNode.nodeClicked = true;
            selectedNode['collapse'] = true;
        }
    }

    onSingleClickSelectedNode(selectedNode: any) {
        console.log(selectedNode);
        selectedNode.offset = null;
        if (selectedNode.id != this.topicId) {
            if (selectedNode.offset != 1 || selectedNode.offset == null || selectedNode.offset == undefined) {
                this.idToRemove = selectedNode.id;
                this.links.forEach((element, i) => {
                    if (element.source.id == this.idToRemove) {
                        //if (element.target.id == this.idToRemove) {
                        this.childNodesArrayToBeDelete.push(element.target);
                    }
                });
                this.callReccursiveToFindChildNodesToBeDelete(this.childNodesArrayToBeDelete);
                this.nodes = this.nodes.filter((objFromA) => {
                    return !this.childNodesArrayToBeDelete.find((objFromB) => {
                        return objFromA.id === objFromB.id;
                    });
                });

                this.links = this.links.filter((objFromA) => {
                    return !this.childNodesArrayToBeDelete.find((objFromB) => {
                        return objFromA.target.id == objFromB.id;
                    });
                });

                selectedNode.nodeClicked = false;
                selectedNode.collapse = false;
                selectedNode.offset = APP_CONFIG.NODE_INITIAL_OFFSET;
                this.childNodesArrayToBeDelete = [];
            } else {
                console.log('selectedNode.offset', selectedNode.offset);
            }
        } else {
            console.log('nodes not yet loaded all child nodes');
        }
    }

    getArticleGraphData(reqPayload: any, isCalledForFirstLevel: boolean, selectedNode: any) {
        this.loadingGraph = true;
        const articleId = isCalledForFirstLevel === true ? reqPayload.articleId : '';
        const nodeId = isCalledForFirstLevel === true ? '' : reqPayload.topicId;

        const personId = this.authService.getPersonId();

        const gyanData = this.localStorageService.getItem('gyanData');
        if (isCalledForFirstLevel) {
            if (gyanData.gyanType === 'rapid') {
                this.articleService.getArticleNetworkDataByArticleId(personId, articleId).subscribe(
                    (response) => {
                        if (response && response.code === 200) {
                            const nodeList = response.data.nodes;
                            this.processGraphData(nodeList, reqPayload, response, isCalledForFirstLevel);
                        } else {
                            this.isCompleted = true;
                            this.message = response.message;
                            //this.toastrService.info(response.message);
                        }
                        this.loadingGraph = false;
                    },
                    (err) => {
                        this.loadingGraph = false;
                        this.isCompleted = true;
                        //    console.log('processGraphData.err', err);
                        this.message = err.error.message;
                        //this.toastrService.error(err.error.message);
                        //add condition for the suppresssummary
                        this.articleNetworkApiHandler.emit(err);
                    },
                );
            } else {
                console.log(gyanData.gyanId);
                const payload = {
                    topicId: this.networkRootIdSub,
                    isHeadNode: true,
                    type: 1,
                    limit: 5,
                    offset: 1,
                    articleId: articleId,
                };
                console.log(payload);
                this.articleService.getArticleNetworkDataByArticleIdForAdvancedQuery(payload).subscribe(
                    (response) => {
                        if (response) {
                            const nodeList = response.nodes;
                            const newResponse = {
                                code: 200,
                                data: response,
                                developerMessage: '',
                                message: '',
                            };
                            console.log('newResponse', newResponse);
                            this.processGraphData(nodeList, reqPayload, newResponse, isCalledForFirstLevel);
                        } else {
                            this.isCompleted = true;
                            this.message = response.message;
                            //this.toastrService.info(response.message);
                        }
                        this.loadingGraph = false;
                    },
                    (err) => {
                        this.loadingGraph = false;
                        this.isCompleted = true;
                        //    console.log('processGraphData.err', err);
                        this.message = err.error.message;
                        //this.toastrService.error(err.error.message);
                        //add condition for the suppresssummary
                        this.articleNetworkApiHandler.emit(err);
                    },
                );
            }
        } else {
            if (gyanData.gyanType === 'rapid') {
                this.articleService.getArticleNetworkDataByNodeId(personId, nodeId).subscribe(
                    (response) => {
                        if (response && response.code === 200) {
                            const data = response.data as unknown as ResponseData;
                            if (data && data.nodes) {
                                let nodeList = data.nodes;
                                nodeList = nodeList.filter((node: any) => node.id !== nodeId);
                                this.processGraphData(nodeList, reqPayload, response, isCalledForFirstLevel);
                            } else {
                                console.log('No more child nodes');
                                selectedNode.isNextLevel = true;
                                selectedNode.nodeClicked = true;
                                selectedNode['collapse'] = true;
                                this.toastrService.info('No more child nodes');
                            }
                            this.loadingGraph = false;
                        } else {
                            this.isCompleted = true;
                            //this.message = response.message;
                        }
                    },
                    (err) => {
                        this.loadingGraph = false;
                        this.isCompleted = true;
                        this.toastrService.error(err.error.message);
                        //this.message = err.error.message;
                        //add condition for the suppresssummary
                        this.articleNetworkApiHandler.emit(err);
                    },
                );
            } else {
                const payload = {
                    topicId: nodeId,
                    isHeadNode: false,
                    type: 2,
                    limit: 5,
                    offset: 1,
                    articleId: articleId,
                };
                console.log(payload);
                this.articleService.getArticleNetworkDataByArticleIdForAdvancedQuery(payload).subscribe(
                    (response) => {
                        if (response) {
                            const nodeList = response.nodes;
                            if (nodeList.length > 0) {
                                const newResponse = {
                                    code: 200,
                                    data: response,
                                    developerMessage: '',
                                    message: '',
                                };
                                console.log('newResponse', newResponse);
                                this.processGraphData(nodeList, reqPayload, newResponse, isCalledForFirstLevel);
                            } else {
                                console.log('No more child nodes');
                                selectedNode.isNextLevel = true;
                                selectedNode.nodeClicked = true;
                                selectedNode['collapse'] = true;
                                this.toastrService.info('No more child nodes');
                            }
                            this.loadingGraph = false;
                        } else {
                            this.isCompleted = true;
                            this.message = response.message;
                            //this.toastrService.info(response.message);
                        }
                        this.loadingGraph = false;
                    },
                    (err) => {
                        this.loadingGraph = false;
                        this.isCompleted = true;
                        //    console.log('processGraphData.err', err);
                        this.message = err.error.message;
                        //this.toastrService.error(err.error.message);
                        //add condition for the suppresssummary
                        this.articleNetworkApiHandler.emit(err);
                    },
                );
            }
        }
    }

    processGraphData(nodeList: any, reqPayload: any, response: any, isCalledForFirstLevel: boolean) {
        nodeList.forEach((node: any) => {
            node['disabled'] = false;
            node['nodeClicked'] = false;
            node['collapse'] = false;
            if (node.id == parseInt(reqPayload.topicId)) {
                node['limit'] = response.limit;
                node['offset'] = response.offset;
            } else {
                node['limit'] = APP_CONFIG.NODE_LIMIT;
                node['offset'] = APP_CONFIG.NODE_INITIAL_OFFSET;
            }
            node.nodeLevel = node.nodeLevel + 1;
        });

        this.setOffset(reqPayload, response);

        this.generateNodes(nodeList, isCalledForFirstLevel);
        this.generateLinks(response.data.links, isCalledForFirstLevel);
        this.isCompleted = true;
        this.headNode = response.data.head_node;
    }

    callReccursiveToFindChildNodesToBeDelete(arrr: any) {
        arrr.forEach((elem: any) => {
            this.links.forEach((ele) => {
                const arr = [];
                if (elem.id == ele.source.id) {
                    arr.push(ele.target);
                    this.childNodesArrayToBeDelete = [...this.childNodesArrayToBeDelete, ...arr];
                    this.callReccursiveToFindChildNodesToBeDelete(arr);
                }
            });
        });
    }

    // updateNodeLevel(data: any, index: number): void {
    //     if (data.nodeLevel === null) {
    //         data.nodeLevel = 1;
    //     }
    //     else{
    //         data.nodeLevel = data.nodeLevel + 1
    //     }
    // }

    setOffset(reqPayload: any, response: any) {
        if (this.nodes.length > 0) {
            this.nodes.forEach((node) => {
                if (node.data.data.isDummy) {
                    if (node.data.data.actualId == parseInt(reqPayload.topicId)) {
                        node['limit'] = response.limit;
                        node['offset'] = response.offset;
                    }
                } else {
                    if (node.id == parseInt(reqPayload.topicId)) {
                        node['limit'] = response.limit;
                        node['offset'] = response.offset;
                    }
                }
            });
        }
    }

    generateNodes(nodeList: any, isCalledForFirstLevel: boolean) {
        const newNodeList = nodeList.map((node: any, i: any) => {
            return new Node({
                linkCount: node.linkCount,
                data: node,
                label: node.label,
                id: node.id,
                disabled: node.disabled,
                nodeClicked: node.nodeClicked,
                nodeLevel: node.nodeLevel,
                limit: node.limit,
                offset: node.offset,
                isNextLevel: node.isNextLevel,
            });
        });
        if (isCalledForFirstLevel) {
            this.nodes = newNodeList;
        } else {
            this.nodes = [...this.nodes, ...newNodeList];
        }
        // if (isCalledForFirstLevel) {
        //     this.nodes = newNodeList;
        // } else {
        //     // uncomment this when, cross connecction of nodes needed
        //     if (this.isNetwork) {
        //         this.createNetwork(newNodeList);
        //     } else {
        //         this.createHirarchy(newNodeList);
        //     }
        // }
    }

    createNetwork(newNodeList: any) {
        const uniqueNode = [];
        for (let i = 0; i < newNodeList.length; i++) {
            const IsPresent = this.nodes.some(function (el) {
                return el.id === newNodeList[i].id;
            });
            if (!IsPresent) {
                uniqueNode.push(newNodeList[i]);
            }
        }

        this.nodes = [...this.nodes, ...uniqueNode];
    }

    createHirarchy(newNodeList: any) {
        this.nodes = [...this.nodes, ...newNodeList];
    }

    generateLinks(linksData: any, isCalledForFirstLevel: boolean) {
        const linksList = linksData;
        const data: any = [];
        linksList.forEach((linkItem: { source: Node; target: Node }) => {
            data.push(new Link(linkItem.source, linkItem.target));
        });

        if (isCalledForFirstLevel) {
            this.links = data;
        } else {
            this.links = [...this.links, ...data];
        }
    }

    ngOnDestroy(): void {
        if (this.articleNetworkSubject) {
            this.articleNetworkSubject.unsubscribe();
        }
    }
}
